import { features } from "../../Components/FeaturesHighlightLogic/FeaturesHighlightLogic";
import React, { useState, useRef,useEffect } from 'react';
const FeaturesHighlight = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [velocity, setVelocity] = useState(0);
  const sliderRef = useRef(null);
  const animationRef = useRef(null);
  const lastTimeRef = useRef(Date.now());
  const lastXRef = useRef(0);


  const cards = [
    {
      title: "Generate 7-figure revenue streams across multiple ASINs",
      description: "Build a diverse, performing products that consistently deliver massive returns"
    },
    {
      title: "Achieve complete operational freedom and passive income",
      description: "Create systems that generate revenue while you focus on strategy and growth"
    },
    {
      title: "Dominate your niche and outperform every competitor",
      description: "Become the undisputed market leader in your category"
    },
    {
      title: "Build a scalable business empire with predictability",
      description: "Develop systems and processes that ensure consistent growth"
    },
    {
      title: "Master data-driven decision making",
      description: "Leverage analytics and insights to optimize every aspect of your business"
    }
  ];

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const animate = () => {
      if (!isDragging && Math.abs(velocity) > 0.1) {
        slider.scrollLeft += velocity;
        setVelocity(velocity * 0.95); // Friction
        animationRef.current = requestAnimationFrame(animate);
      }
    };

    if (!isDragging) {
      animationRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isDragging, velocity]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - sliderRef.current.offsetLeft);
    setScrollLeft(sliderRef.current.scrollLeft);
    setVelocity(0);
    lastXRef.current = e.pageX;
    lastTimeRef.current = Date.now();
    sliderRef.current.style.userSelect = 'none';
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    sliderRef.current.scrollLeft = scrollLeft - walk;

    // Calculate velocity
    const now = Date.now();
    const dt = now - lastTimeRef.current;
    const dx = e.pageX - lastXRef.current;
    
    if (dt > 0) {
      setVelocity(-(dx / dt) * 10);
    }
    
    lastXRef.current = e.pageX;
    lastTimeRef.current = now;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    sliderRef.current.style.userSelect = 'auto';
  };

  const handleMouseLeave = () => {
    if (isDragging) {
      setIsDragging(false);
      sliderRef.current.style.userSelect = 'auto';
    }
  };

  // Touch events
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - sliderRef.current.offsetLeft);
    setScrollLeft(sliderRef.current.scrollLeft);
    setVelocity(0);
    lastXRef.current = e.touches[0].pageX;
    lastTimeRef.current = Date.now();
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    
    const x = e.touches[0].pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    sliderRef.current.scrollLeft = scrollLeft - walk;

    const now = Date.now();
    const dt = now - lastTimeRef.current;
    const dx = e.touches[0].pageX - lastXRef.current;
    
    if (dt > 0) {
      setVelocity(-(dx / dt) * 10);
    }
    
    lastXRef.current = e.touches[0].pageX;
    lastTimeRef.current = now;
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };
  return (
    <>
      <style>{`
        
        .feature-main-container {
          background: linear-gradient(90deg, rgba(8, 16, 40, 0) 0%, #081028 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0px 20px;
          position: relative;
        }

        .feature-main-container .slider-section {
          width: 100%;
          position: relative;
        }

        .feature-main-container .cards-wrapper {
          overflow: hidden;
          padding: 20px 0;
        }

        .feature-main-container .cards-track {
          display: flex;
          gap: 20px;
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          padding: 0 10px;
        }

        .feature-main-container .card {
          width: 360px;
          flex-shrink: 0;
          background: linear-gradient(127.75deg, rgba(203, 199, 252, 0.3) 13.41%, rgba(145, 144, 189, 0.210235) 59.59%, rgba(8, 16, 40, 0) 102.1%);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(167, 139, 250, 0.3);
          border-radius: 16px;
          padding: 40px 32px;
          transition: all 0.3s ease;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
          border-image-source: linear-gradient(142.37deg, #C5C0FF 21.77%, #081028 95.2%);
          color: white;
          transition: all 0.3s ease;
        }

        .feature-main-container .card:hover {
          transform: translateY(-5px);
          background: rgba(139, 92, 246, 0.2);
          border-color: rgba(167, 139, 250, 0.5);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
        }

        .feature-main-container .card h3 {
          color: #ffffff;
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 16px;
          line-height: 1.2;
          font-family: var(--font-family-Geist);
        }

        .feature-main-container .card p {
          color: rgba(255, 255, 255, 0.75);
          font-size: 0.95rem;
          line-height: 1.2;
          margin: 0;
          font-family: var(--font-family-Satoshi);
        }

        .feature-main-container .navigation {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 30px;
          margin-top: 50px;
        }

        .feature-main-container .nav-button {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: rgba(139, 92, 246, 0.2);
          border: 2px solid rgba(167, 139, 250, 0.4);
          color: white;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          user-select: none;
        }

        .feature-main-container .nav-button:hover:not(:disabled) {
          background: rgba(139, 92, 246, 0.35);
          border-color: rgba(167, 139, 250, 0.6);
          transform: scale(1.05);
        }

        .feature-main-container .nav-button:disabled {
          opacity: 0.3;
        }

        .feature-main-container .indicators {
          display: flex;
          gap: 12px;
          align-items: center;
        }

        .feature-main-container .indicator {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.3);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .feature-main-container .indicator.active {
          background: rgba(255, 255, 255, 0.9);
          width: 32px;
          border-radius: 5px;
        }

        @media (max-width: 1200px) {
          .feature-main-container .card {
            min-width: 320px;
          }
        }

        @media (max-width: 768px) {
          .feature-main-container .card {
            min-width: 280px;
            padding: 32px 24px;
          }

         .feature-main-container .card h3 {
            font-size: 28px;
            min-height: auto;
            line-height: 120%;
            letter-spacing: -0.16px;
          }

          .feature-main-container .card p {
            font-size: 22px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 120%;
          }

          .feature-main-container .nav-button {
            width: 48px;
            height: 48px;
            font-size: 20px;
          }

          .feature-main-container .main-container {
            padding: 40px 15px;
          }
        }

        @media (max-width: 576px) {
          .feature-main-container .card {
            min-width: 260px;
            width: 330px;
            height: auto;
            border-radius: 24px;
            gap: 14px;
            angle: 0 deg;
            opacity: 1;
            border-width: 1px;
            padding: 40px;
          }
        }
      `}</style>

      <div className="feature-main-container">
        <div className="slider-section">
          <div className="cards-wrapper"
            ref={sliderRef}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}>
            <div 
              className="cards-track" 
            >
              {cards.map((card, index) => (
                <div key={index} className="card">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
              ))}
            </div>
          </div>
          {/* <div className="scroll-indicator">
            {cards.map((_, index) => (
              <div
                key={index}
                className="indicator-dot"
              />
            ))}
          </div> */}
        </div>
      </div>
    </>
  );
};


export default FeaturesHighlight;
